import React from "react";
import { IoHomeOutline } from "react-icons/io5";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <main className="flex flex-col w-screen h-screen items-center justify-end pb-20 gap-2 bg-gray-100 overflow-hidden text-blue-950">
      <img
        src="/assets/404.png"
        alt="dataReport"
        className="w-[60%]"
      />
      <h1 className="w-full text-center text-5xl">Something wrong here...</h1>
      <h className="w-full text-center text-xl">
        Sorry,we can't find the page you rae looking for.
      </h>
      <div className="flex items-center w-full justify-center gap-2 font-medium">
        <button
          className="flex items-center justify-start border border-black 950 rounded gap-2 px-2 py-1"
          onClick={() => navigate("/home/dash")}
        >
          <IoHomeOutline /> Home
        </button>
        <button
          className="flex items-center justify-start border border-black 950 rounded gap-2 px-2 py-1"
          onClick={() => navigate(-1)}
        >
          <IoArrowBack /> Go Back
        </button>
      </div>
    </main>
  );
}
